import "vue-tsx-support/enable-check"
import {VNode} from 'vue'
import * as tsx from "vue-tsx-support";
import './cellRenderTsx.less'
import './addRemoveRender.less'
import Input from "../../types/iview/Input";
import {CommonUtil} from "../../util/commonUtil";
import {Integer} from "../../types/base";

type Fn = (params: any) => boolean

export interface StringRenderStateI {
	onBlur? (params: any): void

	onStep? (params: any): void

	precision?: String
	editable?: boolean|Fn
}

const StringRender = tsx.componentFactory.create({
	methods: {
		onBlur () {
			let cellRendererFrameworkOpt: StringRenderStateI = ((this.params.colDef.cellRendererFrameworkOpt) as NumberRenderStateI) || {}
			cellRendererFrameworkOpt.onBlur && cellRendererFrameworkOpt.onBlur(this.params)
		},
		onStep () {
			let cellRendererFrameworkOpt: StringRenderStateI = ((this.params.colDef.cellRendererFrameworkOpt) as NumberRenderStateI) || {}
			cellRendererFrameworkOpt.onStep && cellRendererFrameworkOpt.onStep(this.params)
		}
	},
	created () {

	},
	render (h): VNode {
		let cellRendererFrameworkOpt: StringRenderStateI = ((this.params.colDef.cellRendererFrameworkOpt) as NumberRenderStateI) || {}
		let {precision, max, min, editable} = cellRendererFrameworkOpt
		let edit
		if (CommonUtil.isFunction(editable)) {
			edit = editable(this.params)
		} else {
			if (CommonUtil.isUndefined(editable)) {
				edit = true
			} else {
				edit = editable
			}
		}
		return (
			edit ? <Input
					class="wqms-input-number wqms-mb-5"
					precision={precision || 0}
					v-model={this.params.data[this.params.column.colDef.field]}
					on-on-blur={this.onBlur}
					on-steped={this.onStep}
				/> :
				<span>{CommonUtil.isFieldEmpty(this.params.data[this.params.column.colDef.field]) ? '' : CommonUtil.toFixed(this.params.data[this.params.column.colDef.field],(precision || 0))}</span>
		)
	}
})
export default StringRender
